module.exports = __webpack_public_path__ + "media/images/foot-10h10-63c059c16e6ccccd2868e2c777dc3b81.svg";